export const HEADER_HEIGHT_BASE = 40;
export const HEADER_HEIGHT_LG = 50;

export { FOOTER_HEIGHT_BASE, FOOTER_HEIGHT_LG } from "octalog-base/src/components/Footer";
